.objectMenu {
  width: 271px;
  overflow: hidden;
  max-height: calc(100vh - 10px); /* Make sure we can't overflow the viewport */

  /* Overridden in the JS */
  --object-menu-height: 0px;
}

.objectMenuTopBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 6px;
  padding-right: var(--spacer-2);
}

.objectMenuTabs {
  display: flex;
}

.objectMenuTab {
  position: relative;
  padding: 14px 12px;
  cursor: pointer;
  user-select: none;
  color: var(--theme-primary-text);
  font-size: 12px;
  line-height: 12px;
}

.objectMenuTabActive {
  color: var(--aha-blue-500);
}

.objectMenuTabActive::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 10%;
  width: 80%;
  height: 2px;
  background: var(--aha-blue-500);
}

.objectSearchContainer {
  display: flex;
  align-items: center;
  border-top: 1px solid var(--theme-light-border);
  padding: var(--spacer-3);
  padding-bottom: 0;
}

.objectSearchContainer > aha-search-field {
  height: 34px;
  padding-left: 2px;
  border-radius: 4px;
  border: none;
  outline: none;
  box-shadow: none;
  text-indent: 2px;
  --aha-search-field--border-color: none;
  --aha-search-field--background-color: var(--theme-container-background);
}

.objectSearchContainerBackButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  min-width: 34px;
  background-color: var(--theme-container-background);
  border-radius: 4px;
  margin-right: var(--spacer-2);
  cursor: pointer;

  &:hover {
    background-color: var(--theme-button-hovered);
  }
}

.objectSearchContainerBackButton i {
  color: var(--theme-secondary-text);
}

.objectMenuContentContainer {
  max-height: calc(
    var(--object-menu-height) - var(--object-menu-header-height)
  );
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 8px;
  min-height: 200px;
  scrollbar-width: thin;
  scrollbar-color: var(--theme-accent-text) transparent;
}
.objectMenuContentContainer::-webkit-scrollbar {
  width: 6px;
}
.objectMenuContentContainer::-webkit-scrollbar-track {
  background: transparent;
}
.objectMenuContentContainer::-webkit-scrollbar-thumb {
  background: var(--aha-gray-500);
  border-radius: 3px;
}
.objectMenuContentContainer::-webkit-scrollbar-thumb:hover {
  background: var(--aha-gray-600);
}

.objectMenuSectionCollapsed {
  .objectMenuContent {
    height: 0;
    padding-bottom: 0;
    visibility: hidden;
  }

  .objectMenuSectionHeading .arrow > aha-icon {
    transform: rotate(-90deg);
  }
}

.objectMenuSectionHeading {
  cursor: pointer !important;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--theme-secondary-text);
  padding: var(--spacer-1) 0 var(--spacer-1) var(--spacer-1);
  user-select: none;
  line-height: 100%;

  .arrow {
    margin-left: auto;
    padding: 6px;
    border-radius: 4px;

    > aha-icon {
      display: block;
      transition: transform 200ms ease;
    }
  }
  &:hover {
    .arrow {
      background-color: var(--theme-button-hovered);
      color: var(--aha-gray-800);
    }
  }
}

.objectMenuContent {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: var(--spacer-3);
  overflow: hidden;
}

.objectMenuSectionButton {
  background-color: var(--theme-container-light-background);
  border: 1px solid var(--theme-primary-border);
  border-radius: 4px;
  color: var(--theme-primary-text);
  cursor: pointer;
  display: flex;
  margin-top: var(--spacer-2);
  padding: var(--spacer-1) var(--spacer-3);
  height: 29px;
  align-items: center;
  box-sizing: border-box;
  text-align: left;
  width: 100%;
  font-size: 12px;
  opacity: 0.6;

  aha-icon {
    margin-left: auto;
    color: var(--aha-gray-600);
  }
}

.objectMenuSectionButton:hover {
  opacity: 1;

  aha-icon {
    color: var(--aha-gray-800);
  }
}

.objectMenuSectionButtonBackButton {
  margin-bottom: 40px;
  width: unset;
}

.objectMenuEmpty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 192px;
}

.objectMenuEmptyTitle {
  font-size: 12px;
  font-weight: 600;
  color: var(--aha-gray-800);
  margin: 24px 0 8px 0;
}

.objectMenuEmptySubtitle {
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #969696;
}

.objectMenuSearchResult {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid var(--theme-light-border);
}

.objectMenuSearchResult:hover {
  background-color: var(--theme-button-hovered);
}

.objectMenuSearchResult.searchResultActive {
  color: var(--aha-blue-700);
  background-color: var(--aha-blue-100);
}

.objectMenuSearchResultIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
}

.objectMenuSearchResultText {
  color: var(--theme-tertiary-text);
  font-size: 10px;
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
}
